import * as React from 'react';
import { navigate } from 'gatsby';

import Header from '../components/02_molecules/Header/Header';
import AuthSection from '../components/03_organisms/AuthSection/AuthSection';
import useAuth from '../hooks/useAuth';
import Page from '../components/04_templates/Page';
import Footer from '../components/02_molecules/Footer/Footer';
import '../i18n/i18n';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import AndroidPromoLink from '../components/01_atoms/AndroidPromoLink';
import env from '../environment';

function LoginPage() {
  const { isSignedIn, isInitialized } = useAuth();
  const { t } = useTranslation();
  const isPasswordReset =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('reset') === '1';

  React.useEffect(() => {
    if (isInitialized && isSignedIn && !isPasswordReset) {
      navigate(`/app`, { replace: true });
    }
  }, [isInitialized, isPasswordReset, isSignedIn]);

  return (
    <Page title={t('LOGIN_PAGE_META_TITLE')} authRequired={false}>
      <LoginPageContent />
      <Footer />
    </Page>
  );
}

function LoginPageContent() {
  const [resetParams, setResetParams] = React.useState<{
    initialEmail?: string;
    confirmCode?: string;
  }>({});

  React.useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('reset') !== '1') return;

    const initialEmail = searchParams.get('email') || undefined;
    const confirmCode = searchParams.get('resetCode') || undefined;
    if (initialEmail && confirmCode) {
      setResetParams({ initialEmail, confirmCode });
    }
  }, []);

  const { initialEmail, confirmCode } = resetParams;

  return (
    <>
      <Helmet>
        <meta
          name="apple-itunes-app"
          content={`app-id=1638365597, app-argument=${
            typeof window === 'undefined' ? '' : window?.location?.href
          }`}
        />
      </Helmet>
      <AndroidPromoLink />
      <Header
        theme="light"
        backLinkOverride={`${env.GATSBY_BASE_URL}/`}
        showConnectButton={true}
      />
      <AuthSection
        variant={
          initialEmail && confirmCode ? 'confirmResetPassword' : 'signin'
        }
        initialEmail={initialEmail}
        confirmCode={confirmCode}
      />
    </>
  );
}

export default LoginPage;
